import { GetAssignmentProblemsResponseDto } from '../../dtos/responses/get-assignment-problems.response.dto';
import { GetAssignmentSubmitResponseDto } from '../../dtos/responses/get-assignment-submit.response.dto';
import { cn } from '../../lib/utils';

interface SolveProblemNavProps {
  problems: GetAssignmentProblemsResponseDto['problems'];
  submitProblems: GetAssignmentSubmitResponseDto['problems'] | undefined;
  problemId: string;
  onSelect: (id: string) => void;
}

const SolveProblemNav = ({
  problems,
  submitProblems,
  problemId,
  onSelect,
}: SolveProblemNavProps) => {
  return (
    <nav className="sticky top-12 z-20 bg-white border-b border-gray-200">
      <div className="px-3 md:px-6 py-2">
        <ul className="flex gap-2 overflow-x-auto">
          {problems.map((problem, index) => {
            const submitProblem = submitProblems?.find(
              sp => sp.snapshotId === problem.id,
            );
            const isSubmitted = submitProblem?.questions?.some(q => q.answer);
            const submitTime =
              submitProblem?.updatedAt || submitProblem?.createdAt;
            const correctRate =
              submitProblem?.maxScore && submitProblem.maxScore > 0
                ? Math.round(
                    (submitProblem.score / submitProblem.maxScore) * 100,
                  )
                : 0;

            const isActive = problemId === problem.id;

            return (
              <li key={problem.id} className="shrink-0">
                <button
                  type="button"
                  onClick={() => onSelect(problem.id)}
                  className={cn(
                    'flex items-center gap-2 px-2.5 py-1.5 rounded-lg border transition-colors text-left',
                    isActive
                      ? 'bg-primary/10 border-primary'
                      : 'hover:bg-gray-50 border-gray-200 bg-white',
                  )}
                >
                  <span
                    className={cn(
                      'flex items-center justify-center w-6 h-6 rounded-full text-xs font-bold shrink-0',
                      isActive
                        ? 'bg-primary text-white'
                        : 'bg-gray-100 text-gray-700',
                    )}
                  >
                    {index + 1}
                  </span>
                  <div className="flex flex-col text-[11px] leading-tight">
                    <span
                      className={cn(
                        'font-medium',
                        isActive ? 'text-primary' : 'text-gray-900',
                      )}
                    >
                      문제{index + 1}
                    </span>
                    {isSubmitted ? (
                      <>
                        <span className="text-green-600 font-medium">
                          ✓ {correctRate}% 정답
                        </span>
                        {submitTime && (
                          <span className="text-gray-400 hidden sm:inline">
                            {new Date(submitTime).toLocaleDateString('ko-KR', {
                              month: 'short',
                              day: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                            })}
                          </span>
                        )}
                      </>
                    ) : (
                      <span className="text-red-500 font-medium">미제출</span>
                    )}
                  </div>
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};

export default SolveProblemNav;
